import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import { FaThLarge } from 'react-icons/lib/fa'
import styles from './TableSlatePlugin.scss'

class GridButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { hasTable, actions, state: editorState, onChange, style, noTooltip } = this.props
    const isActive = hasTable(editorState)

    const customStyle = {}

    return (
      <Button
        id={'GridButton' + this.uid}
        style={{...style, ...customStyle}}
        onClick={e => onChange(actions.onInsertTable(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.GridButton}
      > <FaThLarge />
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'GridButton' + this.uid} toggle={this.toggle}>
            Grid
          </Tooltip>
        }
      </Button>
    )
  }
}

GridButton.propTypes = {
  hasTable: PropTypes.func,
  actions: PropTypes.object,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default GridButton



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/GridButton.js